// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n1-c";
export var backButton = "_n1-4";
export var backIcon = "_n1-5";
export var chevronShortcut = "_n1-6";
export var container = "_n1-1";
export var editor = "_n1-8";
export var editorWrapper = "_n1-7";
export var prefix = "_n1-2";
export var searchIcon = "_n1-3";
export var suffix = "_n1-9";
export var suffixContent = "_n1-a";
export var suffixText = "_n1-b";
export var wrapper = "_n1-0";